module.exports = __webpack_public_path__ + "static/media/gris_numero_determinado.fd3e4fd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/gris_numero_determinado.svg
// module id = 1752
// module chunks = 0